export default __webpack_public_path__ + "static/media/Background 5_00072.5897ed89.png";